export default "__VITE_ASSET__Cek0RloP__"